/** Enumeration of possible occupancy types. */

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  UUID: any;
};

export type Error = {
  __typename?: 'Error';
  message: Scalars['String'];
};

export type Errors = {
  __typename?: 'Errors';
  fieldErrors: Array<FieldError>;
  nonFieldErrors: Array<Error>;
  systemError?: Maybe<Scalars['Boolean']>;
};

export type FieldError = {
  __typename?: 'FieldError';
  errors: Array<Error>;
  field: Scalars['String'];
};

export enum OccupancyType {
  Investment = 'investment',
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum BadgeType {
  Arm = 'ARM',
  Fha = 'FHA',
  Fixed = 'FIXED',
  Homeready = 'HOMEREADY',
  Conventional = 'CONVENTIONAL',
  Jumbo = 'JUMBO',
  Usda = 'USDA',
  Va = 'VA',
}

export enum LoanTerm {
  Arm5_1 = 'ARM5_1',
  Arm5_6 = 'ARM5_6',
  Arm7_1 = 'ARM7_1',
  Arm7_6 = 'ARM7_6',
  Arm10_1 = 'ARM10_1',
  Arm10_6 = 'ARM10_6',
  Fx15Yr = 'FX15YR',
  Fx20Yr = 'FX20YR',
  Fx30Yr = 'FX30YR',
}

export enum ResidenceType {
  Condo = 'condo',
  Coop = 'coop',
  Manufactured = 'manufactured',
  MultiFamily = 'multi_family',
  Other = 'other',
  SingleFamily = 'single_family',
  Townhouse = 'townhouse',
}

export enum InteractiveQuoteLoanCategory {
  Conventional = 'conventional',
  Fha = 'fha',
  Homeready = 'homeready',
  Usda = 'usda',
  Va = 'va',
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** Sort Field for Search. */
export enum SortField {
  Apr = 'APR',
  LoanCosts = 'LOAN_COSTS',
  PrincipalAndInterest = 'PRINCIPAL_AND_INTEREST',
  Rate = 'RATE',
}
export enum TransactionPurpose {
  Purchase = 'PURCHASE',
  RefiCashOut = 'REFI_CASH_OUT',
  RefiChangeTerms = 'REFI_CHANGE_TERMS',
  RefiGoalNotSet = 'REFI_GOAL_NOT_SET',
  RefiHeloan = 'REFI_HELOAN',
  RefiHeloc = 'REFI_HELOC',
  RefiLowerPayment = 'REFI_LOWER_PAYMENT',
  RefiOther = 'REFI_OTHER',
}

export enum TransactionPurposeTab {
  Purchase = 'PURCHASE',
  Refinance = 'REFINANCE',
  HELOC = 'HELOC',
}

export type WidgetInteractiveRatesFormDataFragmentFragment = {
  __typename?: 'WidgetInteractiveRatesFormData';
  formValues: {
    __typename?: 'WidgetInteractiveRatesFormValues';
    selectedLoanTerms: Array<LoanTerm>;
    selectedIqLoanCategories: Array<InteractiveQuoteLoanCategory>;
    transactionPurpose?: TransactionPurpose | null;
    purchasePrice?: number | null;
    downPayment?: number | null;
    propertyValue?: number | null;
    remainingLoanBalance?: number | null;
    cashOutAmount?: number | null;
    propertyZip?: string | null;
    ficoScore?: number | null;
    annualIncome?: number | null;
    monthlyDebt?: number | null;
    occupancyType?: OccupancyType | null;
    residenceType?: ResidenceType | null;
    numUnits?: number | null;
    totalAssets?: number | null;
    isTargetCashToClose?: boolean | null;
    principalAndInterestMax?: number | null;
    principalAndInterestMin?: number | null;
    equityMax?: number | null;
    equityMin?: number | null;
    interestRateMax?: number | null;
    interestRateMin?: number | null;
    closingCostsMax?: number | null;
    closingCostsMin?: number | null;
    loanCostsMax?: number | null;
    loanCostsMin?: number | null;
    sortField?: SortField | null;
    sortDir?: SortDirection | null;
    clearSettings?: boolean | null;
    clearFilters?: boolean | null;
  };
  rates: Array<{
    __typename?: 'InteractiveRatesRate';
    interestRate: number;
    apr: number;
    monthlyPi: number;
    lenderCredits: number;
    discountPoints: number;
    adjustedPrice: number;
    mortgageBrokerFee: number;
    applicationUnderwritingFee: number;
    creditReportFee: number;
    appraisalFee: number;
    isFha: boolean;
    totalCashToClose: number;
    totalLoanCosts: number;
    totalLoanCostsNew: number;
    loanProgram: {
      __typename?: 'LoanProgram';
      loanTermYears: number;
      fixedTermYears: number;
      adjustmentPeriodMonths: number;
      loanTerm: LoanTerm;
    };
    monthlyCostItems: {
      __typename?: 'TotalCostItem';
      label: string;
      value: string;
      components: Array<
        | {
            __typename?: 'LineItem';
            label: string;
            value: string;
            isGreen?: boolean | null;
            tooltip?: {
              __typename?: 'ToolTip';
              description?: string | null;
              items?: Array<{
                __typename?: 'ToolTipItem';
                value: string;
                label?: string | null;
                isGreen?: boolean | null;
              }> | null;
            } | null;
          }
        | {
            __typename?: 'SubTotalCostItemLevelOne';
            label: string;
            value: string;
            components: Array<
              | {
                  __typename?: 'LineItem';
                  label: string;
                  value: string;
                  isGreen?: boolean | null;
                  tooltip?: {
                    __typename?: 'ToolTip';
                    description?: string | null;
                    items?: Array<{
                      __typename?: 'ToolTipItem';
                      value: string;
                      label?: string | null;
                      isGreen?: boolean | null;
                    }> | null;
                  } | null;
                }
              | {
                  __typename?: 'SubTotalCostItemLevelTwo';
                  label: string;
                  value: string;
                  components: Array<{
                    __typename?: 'LineItem';
                    label: string;
                    value: string;
                    isGreen?: boolean | null;
                    tooltip?: {
                      __typename?: 'ToolTip';
                      description?: string | null;
                      items?: Array<{
                        __typename?: 'ToolTipItem';
                        value: string;
                        label?: string | null;
                        isGreen?: boolean | null;
                      }> | null;
                    } | null;
                  }>;
                }
            >;
          }
        | {
            __typename?: 'SubTotalCostItemLevelTwo';
            label: string;
            value: string;
            components: Array<{
              __typename?: 'LineItem';
              label: string;
              value: string;
              isGreen?: boolean | null;
              tooltip?: {
                __typename?: 'ToolTip';
                description?: string | null;
                items?: Array<{
                  __typename?: 'ToolTipItem';
                  value: string;
                  label?: string | null;
                  isGreen?: boolean | null;
                }> | null;
              } | null;
            }>;
          }
      >;
    };
    cashToCloseCostItems: {
      __typename?: 'TotalCostItem';
      label: string;
      value: string;
      components: Array<
        | {
            __typename?: 'LineItem';
            label: string;
            value: string;
            isGreen?: boolean | null;
            tooltip?: {
              __typename?: 'ToolTip';
              description?: string | null;
              items?: Array<{
                __typename?: 'ToolTipItem';
                value: string;
                label?: string | null;
                isGreen?: boolean | null;
              }> | null;
            } | null;
          }
        | {
            __typename?: 'SubTotalCostItemLevelOne';
            label: string;
            value: string;
            components: Array<
              | {
                  __typename?: 'LineItem';
                  label: string;
                  value: string;
                  isGreen?: boolean | null;
                  tooltip?: {
                    __typename?: 'ToolTip';
                    description?: string | null;
                    items?: Array<{
                      __typename?: 'ToolTipItem';
                      value: string;
                      label?: string | null;
                      isGreen?: boolean | null;
                    }> | null;
                  } | null;
                }
              | {
                  __typename?: 'SubTotalCostItemLevelTwo';
                  label: string;
                  value: string;
                  components: Array<{
                    __typename?: 'LineItem';
                    label: string;
                    value: string;
                    isGreen?: boolean | null;
                    tooltip?: {
                      __typename?: 'ToolTip';
                      description?: string | null;
                      items?: Array<{
                        __typename?: 'ToolTipItem';
                        value: string;
                        label?: string | null;
                        isGreen?: boolean | null;
                      }> | null;
                    } | null;
                  }>;
                }
            >;
          }
        | {
            __typename?: 'SubTotalCostItemLevelTwo';
            label: string;
            value: string;
            components: Array<{
              __typename?: 'LineItem';
              label: string;
              value: string;
              isGreen?: boolean | null;
              tooltip?: {
                __typename?: 'ToolTip';
                description?: string | null;
                items?: Array<{
                  __typename?: 'ToolTipItem';
                  value: string;
                  label?: string | null;
                  isGreen?: boolean | null;
                }> | null;
              } | null;
            }>;
          }
      >;
    };
    badges: Array<{
      __typename?: 'RateRowBadge';
      badgeType: BadgeType;
      label: string;
      tooltip: string;
    }>;
  }>;
  sliderRanges: {
    __typename?: 'WidgetInteractiveRatesSliderRanges';
    monthlyPaymentRange: Array<number>;
    equityRange: Array<number>;
    closingCostsRange: Array<number>;
    interestRatesRange: Array<number>;
    totalLoanCostsRange: Array<number>;
    principalAndInterestRange: Array<number>;
  };
  principalAndInterestIsDefault: boolean;
  equityIsDefault: boolean;
  closingCostsIsDefault: boolean;
  interestRateIsDefault: boolean;
  loanCostsIsDefault: boolean;
};

export type WidgetInteractiveRatesSliderRangesFragmentFragment = {
  __typename?: 'WidgetInteractiveRatesSliderRanges';
  monthlyPaymentRange: Array<number>;
  equityRange: Array<number>;
  closingCostsRange: Array<number>;
  interestRatesRange: Array<number>;
  totalLoanCostsRange: Array<number>;
  principalAndInterestRange: Array<number>;
};
export type WidgetInteractiveRatesFormValuesFragmentFragment = {
  __typename?: 'WidgetInteractiveRatesFormValues';
  selectedLoanTerms: Array<LoanTerm>;
  selectedIqLoanCategories: Array<InteractiveQuoteLoanCategory>;
  transactionPurpose?: TransactionPurpose | null;
  purchasePrice?: number | null;
  downPayment?: number | null;
  propertyValue?: number | null;
  remainingLoanBalance?: number | null;
  cashOutAmount?: number | null;
  propertyZip?: string | null;
  ficoScore?: number | null;
  annualIncome?: number | null;
  monthlyDebt?: number | null;
  occupancyType?: OccupancyType | null;
  residenceType?: ResidenceType | null;
  numUnits?: number | null;
  totalAssets?: number | null;
  isTargetCashToClose?: boolean | null;
  principalAndInterestMax?: number | null;
  principalAndInterestMin?: number | null;
  equityMax?: number | null;
  equityMin?: number | null;
  interestRateMax?: number | null;
  interestRateMin?: number | null;
  closingCostsMax?: number | null;
  closingCostsMin?: number | null;
  loanCostsMax?: number | null;
  loanCostsMin?: number | null;
  monthlyPropertyTaxes?: number | null;
  monthlyHoi?: number | null;
  monthlyHoa?: number | null;
  sellerCredits?: number | null;
  earnestMoneyDeposit?: number | null;
  isEscrowWaived?: boolean | null;
  sortField?: SortField | null;
  sortDir?: SortDirection | null;
  clearSettings?: boolean | null;
  clearFilters?: boolean | null;
};

export type ToolTipFragmentFragment = {
  __typename?: 'ToolTip';
  description?: string | null;
  items?: Array<{
    __typename?: 'ToolTipItem';
    value: string;
    label?: string | null;
    isGreen?: boolean | null;
  }> | null;
};

export type TotalCostItemFragmentFragment = {
  __typename?: 'TotalCostItem';
  label: string;
  value: string;
  components: Array<
    | {
        __typename?: 'LineItem';
        label: string;
        value: string;
        isGreen?: boolean | null;
        tooltip?: {
          __typename?: 'ToolTip';
          description?: string | null;
          items?: Array<{
            __typename?: 'ToolTipItem';
            value: string;
            label?: string | null;
            isGreen?: boolean | null;
          }> | null;
        } | null;
      }
    | {
        __typename?: 'SubTotalCostItemLevelOne';
        label: string;
        value: string;
        components: Array<
          | {
              __typename?: 'LineItem';
              label: string;
              value: string;
              isGreen?: boolean | null;
              tooltip?: {
                __typename?: 'ToolTip';
                description?: string | null;
                items?: Array<{
                  __typename?: 'ToolTipItem';
                  value: string;
                  label?: string | null;
                  isGreen?: boolean | null;
                }> | null;
              } | null;
            }
          | {
              __typename?: 'SubTotalCostItemLevelTwo';
              label: string;
              value: string;
              components: Array<{
                __typename?: 'LineItem';
                label: string;
                value: string;
                isGreen?: boolean | null;
                tooltip?: {
                  __typename?: 'ToolTip';
                  description?: string | null;
                  items?: Array<{
                    __typename?: 'ToolTipItem';
                    value: string;
                    label?: string | null;
                    isGreen?: boolean | null;
                  }> | null;
                } | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'SubTotalCostItemLevelTwo';
        label: string;
        value: string;
        components: Array<{
          __typename?: 'LineItem';
          label: string;
          value: string;
          isGreen?: boolean | null;
          tooltip?: {
            __typename?: 'ToolTip';
            description?: string | null;
            items?: Array<{
              __typename?: 'ToolTipItem';
              value: string;
              label?: string | null;
              isGreen?: boolean | null;
            }> | null;
          } | null;
        }>;
      }
  >;
};

export type ToolTipItemFragmentFragment = {
  __typename?: 'ToolTipItem';
  value: string;
  label?: string | null;
  isGreen?: boolean | null;
};

export type LineItemFragmentFragment = {
  __typename?: 'LineItem';
  label: string;
  value: string;
  isGreen?: boolean | null;
  tooltip?: {
    __typename?: 'ToolTip';
    description?: string | null;
    items?: Array<{
      __typename?: 'ToolTipItem';
      value: string;
      label?: string | null;
      isGreen?: boolean | null;
    }> | null;
  } | null;
};

export type InteractiveRatesRateFragmentFragment = {
  __typename?: 'InteractiveRatesRate';
  interestRate: number;
  apr: number;
  monthlyPi: number;
  lenderCredits: number;
  discountPoints: number;
  adjustedPrice: number;
  mortgageBrokerFee: number;
  applicationUnderwritingFee: number;
  creditReportFee: number;
  appraisalFee: number;
  isFha: boolean;
  totalLoanCosts: number;
  totalLoanCostsNew: number;
  totalCashToClose: number;
  loanProgram: {
    __typename?: 'LoanProgram';
    loanTermYears: number;
    fixedTermYears: number;
    adjustmentPeriodMonths: number;
    loanTerm: LoanTerm;
  };
  monthlyCostItems: {
    __typename?: 'TotalCostItem';
    label: string;
    value: string;
    components: Array<
      | {
          __typename?: 'LineItem';
          label: string;
          value: string;
          isGreen?: boolean | null;
          tooltip?: {
            __typename?: 'ToolTip';
            description?: string | null;
            items?: Array<{
              __typename?: 'ToolTipItem';
              value: string;
              label?: string | null;
              isGreen?: boolean | null;
            }> | null;
          } | null;
        }
      | {
          __typename?: 'SubTotalCostItemLevelOne';
          label: string;
          value: string;
          components: Array<
            | {
                __typename?: 'LineItem';
                label: string;
                value: string;
                isGreen?: boolean | null;
                tooltip?: {
                  __typename?: 'ToolTip';
                  description?: string | null;
                  items?: Array<{
                    __typename?: 'ToolTipItem';
                    value: string;
                    label?: string | null;
                    isGreen?: boolean | null;
                  }> | null;
                } | null;
              }
            | {
                __typename?: 'SubTotalCostItemLevelTwo';
                label: string;
                value: string;
                components: Array<{
                  __typename?: 'LineItem';
                  label: string;
                  value: string;
                  isGreen?: boolean | null;
                  tooltip?: {
                    __typename?: 'ToolTip';
                    description?: string | null;
                    items?: Array<{
                      __typename?: 'ToolTipItem';
                      value: string;
                      label?: string | null;
                      isGreen?: boolean | null;
                    }> | null;
                  } | null;
                }>;
              }
          >;
        }
      | {
          __typename?: 'SubTotalCostItemLevelTwo';
          label: string;
          value: string;
          components: Array<{
            __typename?: 'LineItem';
            label: string;
            value: string;
            isGreen?: boolean | null;
            tooltip?: {
              __typename?: 'ToolTip';
              description?: string | null;
              items?: Array<{
                __typename?: 'ToolTipItem';
                value: string;
                label?: string | null;
                isGreen?: boolean | null;
              }> | null;
            } | null;
          }>;
        }
    >;
  };
  cashToCloseCostItems: {
    __typename?: 'TotalCostItem';
    label: string;
    value: string;
    components: Array<
      | {
          __typename?: 'LineItem';
          label: string;
          value: string;
          isGreen?: boolean | null;
          tooltip?: {
            __typename?: 'ToolTip';
            description?: string | null;
            items?: Array<{
              __typename?: 'ToolTipItem';
              value: string;
              label?: string | null;
              isGreen?: boolean | null;
            }> | null;
          } | null;
        }
      | {
          __typename?: 'SubTotalCostItemLevelOne';
          label: string;
          value: string;
          components: Array<
            | {
                __typename?: 'LineItem';
                label: string;
                value: string;
                isGreen?: boolean | null;
                tooltip?: {
                  __typename?: 'ToolTip';
                  description?: string | null;
                  items?: Array<{
                    __typename?: 'ToolTipItem';
                    value: string;
                    label?: string | null;
                    isGreen?: boolean | null;
                  }> | null;
                } | null;
              }
            | {
                __typename?: 'SubTotalCostItemLevelTwo';
                label: string;
                value: string;
                components: Array<{
                  __typename?: 'LineItem';
                  label: string;
                  value: string;
                  isGreen?: boolean | null;
                  tooltip?: {
                    __typename?: 'ToolTip';
                    description?: string | null;
                    items?: Array<{
                      __typename?: 'ToolTipItem';
                      value: string;
                      label?: string | null;
                      isGreen?: boolean | null;
                    }> | null;
                  } | null;
                }>;
              }
          >;
        }
      | {
          __typename?: 'SubTotalCostItemLevelTwo';
          label: string;
          value: string;
          components: Array<{
            __typename?: 'LineItem';
            label: string;
            value: string;
            isGreen?: boolean | null;
            tooltip?: {
              __typename?: 'ToolTip';
              description?: string | null;
              items?: Array<{
                __typename?: 'ToolTipItem';
                value: string;
                label?: string | null;
                isGreen?: boolean | null;
              }> | null;
            } | null;
          }>;
        }
    >;
  };
  badges: Array<{
    __typename?: 'RateRowBadge';
    badgeType: BadgeType;
    label: string;
    tooltip: string;
  }>;
};

export type RateRowBadge = {
  __typename?: 'RateRowBadge';
  badgeType: BadgeType;
  label: Scalars['String'];
  tooltip: Scalars['String'];
};
